export function TimerFilled({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.9996 14.3125C48.5258 14.3125 59.5375 25.3504 59.5377 38.8789C59.5377 52.4064 48.5271 63.417 34.9996 63.417C21.4735 63.4168 10.4625 52.3781 10.4625 38.8496C10.4627 25.3225 21.4725 14.3127 34.9996 14.3125ZM34.9996 20.3955C33.3898 20.3957 32.0623 21.7232 32.0621 23.333V37.917C32.0623 39.5268 33.3898 40.8543 34.9996 40.8545C36.6095 40.8545 37.9369 39.5269 37.9371 37.917V23.333C37.9369 21.7231 36.6095 20.3955 34.9996 20.3955Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M26.5704 6.5835H43.4288C44.1812 6.5835 44.7792 7.18084 44.7794 7.93311C44.7794 8.69909 44.1679 9.31299 43.4288 9.31299H26.5704C25.8182 9.31278 25.2208 8.71473 25.2208 7.9624C25.221 7.19667 25.8316 6.58371 26.5704 6.5835Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
